<template>
  <div class="dashboard-container">
    <adminDashboard />
    <!-- <el-button @click="fuck">123123</el-button> -->
    <!-- <component :is="currentRole" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import adminDashboard from './admin'
// import editorDashboard from './editor'

export default {

  components: { adminDashboard },
  data() {
    return {
      currentRole: 'adminDashboard'
    }
  },
  computed: {
    ...mapGetters([
      'roles'
    ])
  },
  mounted() {
  },
  methods: {
    // fuck(){
    //   this.$message.success({
    //     duration:0,
    //     message:'123123123'
    //   })
    // }
  }

}
</script>
